<template>
    <div>
        <data-grid
            :url="url"
            :columns="columns"
            :title="title"
            :actions="actions"
            navigationPath="Property"
            navigationField="id"
            :sortOptions="{
                enabled: true,
                field: 'date',
                type: 'desc',
            }"
            ref="grid"
        ></data-grid>
    </div>
</template>

<script>
import moment from "moment";
import { getDomain, formatCurrency } from "../utils/helpers.js";

export default {
    data: () => ({
        title: "Properties",
        columns: [
            // {
            //     field: "status",
            //     isIcon: true,
            //     icon: (value) => {
            //         if (!value) return "";

            //         switch (value.trim()) {
            //             case "ERROR":
            //             case "FAILED":
            //                 return "mdi-message-alert";
            //             case "NEW":
            //                 return "mdi-message-plus";
            //             case "QUEUED":
            //             case "WAITING":
            //             case "PENDING":
            //                 return "mdi-message-processing";
            //             case "SENT":
            //                 return "mdi-comment-arrow-right";
            //             case "DELIVERED":
            //                 return "mdi-message-text";
            //             case "UNDELIVERED":
            //                 return "mdi-close-circle";
            //             default:
            //                 return "";
            //         }
            //     },
            //     iconColor: (value) => {
            //         if (!value) return "";

            //         switch (value.trim()) {
            //             case "ERROR":
            //             case "FAILED":
            //             case "UNDELIVERED":
            //                 return "#f35123";
            //             case "NEW":
            //                 return "info";
            //             case "QUEUED":
            //             case "WAITING":
            //             case "PENDING":
            //                 return "#fdb400";
            //             case "DELIVERED":
            //                 return "success";
            //             case "SENT":
            //                 return "#aeb8bf";
            //             default:
            //                 return "#aeb8bf";
            //         }
            //     },
            // },

            {
                sortable: true,
                label: "Address",
                field: "address",
                hidden: false,
                filterOptions: {
                    enabled: true,
                },
            },
            {
                sortable: true,
                label: "Date",
                field: "date",
                type: "date",
                dateOutputFormat: "MM/DD/YYYY h:mm:ss A",
                hidden: false,
                filterOptions: {
                    enabled: true,
                },
            },
            {
                sortable: false,
                label: "Purchase Price",
                field: "purchasePrice",
                type: "number",
                formatFn: (value) => {
                    return formatCurrency(value);
                },
                hidden: false,
                filterOptions: {
                    enabled: true,
                },
            },
            {
                sortable: false,
                label: "Debit",
                field: "debit",
                type: "number",
                formatFn: (value) => {
                    return formatCurrency(value);
                },
                hidden: false,
                filterOptions: {
                    enabled: true,
                },
            },
            {
                sortable: false,
                label: "Credit",
                field: "credit",
                type: "number",
                formatFn: (value) => {
                    return formatCurrency(value);
                },
                hidden: false,
                filterOptions: {
                    enabled: true,
                },
            },
            {
                sortable: false,
                label: "SQFT",
                field: "sqft",
                type: "number",
                hidden: false,
                filterOptions: {
                    enabled: true,
                },
            },
            {
                sortable: false,
                label: "Beds",
                field: "beds",
                type: "number",
                hidden: false,
                filterOptions: {
                    enabled: true,
                },
            },
            {
                sortable: false,
                label: "Bathrooms",
                field: "bathrooms",
                type: "number",
                hidden: false,
                filterOptions: {
                    enabled: true,
                },
            },
        ],

        actions: [
            {
                text: "Send Message",
                link: "SendMessage",
            },
        ],

        url: "",
    }),
    watch: {},
    created() {
        this.url = "properties?userName=" + this.$store.state.user;
    },
    methods: {},
};
</script>
<style>
[v-cloak] {
    display: none;
}

.border-line {
    border: black 1px solid;
}

.scroll {
    overflow-y: auto;
}
</style>
